import { projectStorage } from '@tencent/fd-utils';
import { useConfigStore } from '@/store/modules/config';
import { AuthVerifyTypeEnum, CreateProfileModeEnum } from '@/enums/CommonEnum';
import { router } from '@/router';
import { showNotify, showConfirmDialog, showDialog } from 'vant';
import { useRecordsStore } from '@/store/modules/records';

const configStore = useConfigStore();
const recordsStore = useRecordsStore();
const goHealthCardAuth = () => {
  const hospitalId = configStore.dict?.dynamicConfig.feSysConfig.healthCardHospitalId;
  if (!hospitalId) {
    showNotify({ type: 'danger', message: '未配置健康卡医疗机构信息，请联系管理员' });
    return;
  }
  const redirectUri = window.location.href
    .replace('/records/guide', '/records/AuthHealthCode')
    .replace('/pages/home', '/records/AuthHealthCode');
  const url = `https://h5-health.tengmed.com/h5/tencent/open/card/regist?hospitalId=${hospitalId}&redirect_uri=${encodeURIComponent(
    redirectUri,
  )}&fail_redirect_uri=${encodeURIComponent(redirectUri)}`;
  window.location.href = url;
};

export const goAddRecord = async () => {
  if (!projectStorage.get('isAuth')) {
    window.location.href = '/pages/home';
  } else {
    const recordAddWays = configStore.dict?.dynamicConfig.feSysConfig.verifyType;
    if (!recordAddWays?.length) {
      showNotify({ type: 'danger', message: '未配置建档方式，请联系管理员' });
      return;
    }
    if (recordAddWays.length === 1) {
      const recordAddWay = recordAddWays[0];
      // 1,配置了仅健康卡导入
      if (recordAddWay === AuthVerifyTypeEnum.healthcard) {
        showConfirmDialog({
          title: '实名认证',
          message: '为了保证建档信息的安全性、真实性及唯一性，请先前往电子健康卡授权实名认证',
          confirmButtonText: '前往授权',
        })
          .then(() => {
            goHealthCardAuth();
          })
          .catch(() => {
            // on cancel
          });
        // 2,仅配置手动填写或者ocr
      } else {
        router.push({ name: 'auth-base-info' });
      }
    } else {
      // 4,配置了健康卡导入和手动填写
      if (recordAddWays.findIndex((recordAddWay) => recordAddWay === AuthVerifyTypeEnum.healthcard) > -1) {
        showConfirmDialog({
          title: '实名认证',
          message: '为了保证建档信息的安全性、真实性及唯一性，请先实名认证',
          cancelButtonText: '手动填写认证',
          confirmButtonText: '前往授权',
        })
          .then(() => {
            goHealthCardAuth();
          })
          .catch(() => {
            router.push({ name: 'auth-base-info' });
          });
      } else {
        router.push({ name: 'auth-base-info' });
      }
    }
  }
};

export const queryPatient = async (params) => {
  const createProfileMode = configStore.dict?.dynamicConfig?.feSysConfig?.createProfileMode;
  const queryBody = {
    certType: params.certType,
    certNo: params.certNo,
    fullName: params.fullName,
    gender: params.gender,
  };
  const res = await recordsStore.queryPatient(queryBody);
  if (!res) return;
  console.log('queryPatient', res);
  const { status } = res;
  recordsStore.setRecords(null, null);
  if (status === 0) {
    recordsStore.setRecordsItems(Object.keys(params), Object.values(params));
    recordsStore.setUserRelation(params.relation);
    recordsStore.setRecords(res.profile, res.org);
    router.push({ name: 'add-record-step1' });
  } else if (status === 1) {
    if (createProfileMode !== CreateProfileModeEnum.sync) {
      recordsStore.setRecordsItems(Object.keys(params), Object.values(params));
      recordsStore.setUserRelation(params.relation);
      recordsStore.setRecordsItem('profileStatus', 0);
      router.push({ name: 'add-record-step1' });
    } else {
      showDialog({
        title: '认证失败',
        message: '当前证件号暂无建档信息，请联系相关人员线下操作后重试',
      });
    }
  } else {
    showDialog({
      title: '认证失败',
      message: '证件信息有误，请仔细核对，修改后重试',
    });
  }
};
